const MessageLayout = (props) => {
  return (
    <div className='w-full md:w-1/2 lg:w-1/3 mt-20 md:mt-0 text-base leading-relaxed text-center text-discord_white bg-jams_dark_blue p-10 rounded-xl border-4 border-jams_blue'>
      {props.children}
    </div>
  )
}

export default MessageLayout
